(function (angular) {
    "use strict";
    var fmgApp = angular.module('FmgProduceSuite-Launcher');

    fmgApp.controller('SetPasswordController', function ($scope, $state, $stateParams,Analytics, accountManagementService, screenBlockService, authenticationService,locker) {
        $scope.showCompletedMessage = false;
        $scope.errorMessage = null;

        $scope.user = {};
        $scope.invalidCode = false;

        $scope.OnInit = function(){
            $scope.user.code = $stateParams.code;
            // $scope.user.displayName = authenticationService.getToken().identity.displayName;

            if(!authenticationService.getToken()){
                console.log('Doing Login with Code');

                authenticationService.loginWithCode($stateParams.code,function(resetPassword,resetCode) {
                    $scope.user.code = resetCode;
                },function(statusCode){
                    $scope.invalidCode = true;
                });
            }
        };

        $scope.checkPassword = function(pwd){
            authenticationService.tryPassword(pwd).then(function(response){
                // response.data.Ok;
                // response.data.Reason;
            },function(errorResponse){

            });
        };

        $scope.setPassword = function (form) {


            $scope.errorMessage = null;

            if (form.$valid) {
                if ($scope.user.password1 !== $scope.user.password2) {
                    $scope.errorMessage = "The new password fields do not match.  Please check and try again.";
                    return;
                }

                var complexResult = $scope.checkComplexity($scope.user.password1);
                if(complexResult){
                    $scope.errorMessage = complexResult;
                    return;
                }

                Analytics.trackEvent('setPassword', $scope.user.displayName);

                screenBlockService.blockScreen();

                accountManagementService.setPassword($scope.user.code, $scope.user.password1)
                    .then(function (response) {

                        screenBlockService.clearScreen();

                        locker.put('token', response.data);
                        $state.go('list');

                    }, function (errorResponse) {
                        $scope.errorMessage = 'Failed To Set Password';
                        if(errorResponse.data && errorResponse.data.Message) {
                            $scope.errorMessage = errorResponse.data.Message;
                        }

                        screenBlockService.clearScreen();
                    });
            }
        };

        $scope.changePassword = function (form) {
            $scope.errorMessage = null;

            if (form.$valid) {
                if ($scope.user.password1 !== $scope.user.password2) {
                    $scope.errorMessage = "New Password does not match the Repeated New Password.  Please check and try again.";
                    return;
                }

                screenBlockService.blockScreen();

                accountManagementService.setPassword($scope.code, $scope.user.password1)
                    .then(function (response) {
                        screenBlockService.clearScreen();
                        alert('Your Password has been reset.');
                        $state.go('default');
                    }, function (errorResponse) {
                        screenBlockService.clearScreen();
                        alert('Error Connecting to Service');
                    });
            }
        };

        $scope.cancelFromSetPassword = function(){
            authenticationService.logout();
        };

        $scope.cancelFromChangePassword = function(){
            $state.go('default');
        };

        $scope.checkComplexity = function(pwd){

            if(pwd){
                var length = pwd.length >= 9;

                var hasUpperCase = /[A-Z]/.test(pwd);
                var hasLowerCase = /[a-z]/.test(pwd);
                var hasNumbers = /\d/.test(pwd);
                var hasNonalphas = /\W/.test(pwd);

                if(!length){
                    return 'Passwords must have a minimum length of 9 characters';
                }

                var points = 0;
                if(hasUpperCase){
                    points = points + 1;
                }
                if(hasLowerCase){
                    points = points + 1;
                }
                if(hasNumbers){
                    points = points + 1;
                }
                if(hasNonalphas){
                    points = points + 1;
                }
                if(points < 3){
                    return 'Password Must contain a mixture of at least three of the following - Uppercase, lowercase, numerals and non-alphanumeric ’special characters’'
                }

                return null;

            }else{
                return 'No Password Set';
            }

        }

    });
})(window.angular);